import axios from "axios";
import { API_URL, del, get, post, put } from "../api_helper";
import userService from "../user.service";

const base = (appointmentId) =>
  `appointments/${appointmentId}/video-session`;

export const startVideoSession = (appointmentId) =>
  post(`${base(appointmentId)}/start`, {});

export const getVideoSessionJoinContext = (appointmentId) =>
  get(`${base(appointmentId)}/join-context`);

export const markVideoSessionHostReady = (appointmentId) =>
  post(`${base(appointmentId)}/host-ready`, {});

export const heartbeatVideoSessionHost = (appointmentId) =>
  post(`${base(appointmentId)}/host-heartbeat`, {});

export const markVideoSessionStartFailed = (appointmentId, message) =>
  post(`${base(appointmentId)}/start-failed`, { message });

export const endVideoSession = (appointmentId) =>
  post(`${base(appointmentId)}/end`, {});

export const auditVideoSessionCommand = (appointmentId, payload) =>
  post(`${base(appointmentId)}/audit-command`, payload);

export const createVideoSessionInvite = (appointmentId, payload) =>
  post(`${base(appointmentId)}/invites`, payload);

export const listVideoSessionInvites = (appointmentId) =>
  get(`${base(appointmentId)}/invites`);

export const revokeVideoSessionInvite = (appointmentId, inviteId) =>
  post(`${base(appointmentId)}/invites/${inviteId}/revoke`, {});

export const resendVideoSessionInvite = (appointmentId, inviteId) =>
  post(`${base(appointmentId)}/invites/${inviteId}/resend`, {});

export const getVideoSessionNote = (appointmentId) =>
  get(`${base(appointmentId)}/notes`);

export const saveVideoSessionNote = (appointmentId, payload) =>
  put(`${base(appointmentId)}/notes`, payload);

export const finalizeVideoSessionNote = (appointmentId) =>
  post(`${base(appointmentId)}/notes/finalize`, {});

export const getVideoSessionVitals = (appointmentId) =>
  get(`${base(appointmentId)}/vitals`);

export const saveVideoSessionVital = (appointmentId, payload) =>
  put(`${base(appointmentId)}/vitals`, payload);

export const getVideoSessionCaptureStatus = (appointmentId) =>
  get(`${base(appointmentId)}/captures/status`);

export const listVideoSessionCaptures = (appointmentId) =>
  get(`${base(appointmentId)}/captures`);

export const saveVideoSessionScreenshot = (
  appointmentId,
  image,
  payload,
) => {
  const form = new FormData();
  form.append("image", image, "screenshot.jpg");
  Object.entries(payload).forEach(([key, value]) =>
    form.append(key, String(value)),
  );
  return post(`${base(appointmentId)}/captures/screenshots`, form);
};

export const startVideoSessionAudioCapture = (appointmentId, payload) =>
  post(`${base(appointmentId)}/captures/audio/start`, payload);

export const stopVideoSessionAudioCapture = (appointmentId, captureId) =>
  post(`${base(appointmentId)}/captures/audio/${captureId}/stop`, {});

export const deleteVideoSessionCapture = (appointmentId, captureId) =>
  del(`${base(appointmentId)}/captures/${captureId}`);

export const getVideoSessionCaptureBlob = async (
  appointmentId,
  captureId,
) => {
  const token = userService.Get_Token();
  const response = await axios.get(
    `${API_URL}api/${base(appointmentId)}/captures/${captureId}/content`,
    {
      responseType: "blob",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    },
  );
  return response.data;
};

export const getGuestVideoSessionInvite = async (token) => {
  try {
    const response = await axios.get(`${API_URL}api/video-session/guest/${token}`);
    return response.data;
  } catch (error) {
    return error.response?.data || {
      isSuccess: false,
      statusCode: error.response?.status || 500,
      message: error.message || "Unable to load invite.",
      data: null,
    };
  }
};

export const joinGuestVideoSession = async (token, payload) => {
  try {
    const response = await axios.post(
      `${API_URL}api/video-session/guest/${token}/join`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || {
      isSuccess: false,
      statusCode: error.response?.status || 500,
      message: error.message || "Unable to join session.",
      data: null,
    };
  }
};
